<app-scanner></app-scanner>

<div class="transport-plan-header">
  <ng-container *ngIf="itemData; else noItem">
    <span>{{ itemData.contractNumber }}</span>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <span>{{ itemData.itemNumber}}</span>
  </ng-container>
  <ng-template #noItem>
    <span>{{ title }}</span>
  </ng-template>
</div>

<div class="transport-plan-error" *ngIf="errorMessage">
  <span>{{ errorMessage }}</span>
</div>

<div class="transport-plan-spinner">
  <mat-progress-spinner *ngIf="busy" color="primary" mode="indeterminate" diameter="40"></mat-progress-spinner>
</div>

<!-- transport plan -->
<div class="transport-plan-content">
  <ng-container *ngIf="!!itemData && !!itemData.productName">
    <div class="product-name">{{ itemData.productName }}</div>
  </ng-container>
  <div *ngIf="transportPlanData" class="transport-plan">
    <div class="no-select" [innerHTML]="transportPlanHtml"></div>
  </div>
</div>

<div class="transport-plan-footer">
  <div class="transport-plan-footer-col-left">
    <button class="transport-plan-back-button" (click)="goBack()" [disabled]="toolbar.navigationBlocked$ | async" mat-icon-button>
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div *ngIf="transportPlanData"
       class="transport-plan-changed-at">{{ 'transportPlan.changedAt' | translate }} {{ transportPlanData.changedAt }}</div>
  </div>
  <div *ngIf="addressHtml" class="transport-plan-footer-col-right" [innerHTML]="addressHtml"></div>
</div>
